import { render } from "./OutgoingGoodsProducer.vue?vue&type=template&id=c0aeda06"
import script from "./OutgoingGoodsProducer.vue?vue&type=script&lang=js"
export * from "./OutgoingGoodsProducer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__